import layout from '@/layout'

export default {
  path: '/auth',
  component: layout,
  redirect: '/auth/order',
  name: 'auth',
  meta: {
    title: 'auth',
    icon: 'el-icon-tickets'
  },
  children: [
    {
      path: '/auth/order',
      name: 'authOrder',
      component: () => import('@/views/auth'),
      meta: {
        title: 'authOrder',
        icon: 'el-icon-tickets'
      }
    },
    {
      path: '/auth/order_detail/:id/:type',
      name: 'authOrderDetail',
      component: () => import('@/views/auth/authOrderDetail'),
      meta: {
        title: 'authOrderDetail'
      }
    },
    {
      path: '/auth/order_invoice/:id/:type',
      name: 'authOrderInvoice',
      component: () => import('@/views/auth/authOrderInvoice'),
      meta: {
        title: 'authOrderInvoice'
      }
    },
    {
      path: '/auth/order_id_card/:id/:type',
      name: 'authOrderIdCard',
      component: () => import('@/views/auth/authOrderIdCard'),
      meta: {
        title: 'authOrderIdCard'
      }
    },
    {
      path: '/auth/order_driving_card/:id/:type',
      name: 'authOrderDrivingCard',
      component: () => import('@/views/auth/authOrderDrivingCard'),
      meta: {
        title: 'authOrderDrivingCard'
      }
    }
  ]
}
